import React from "react"
import PropTypes from "prop-types"
import { CalendarDropdown } from "@swipesense/calendar"
import MomentPropTypes from "react-moment-proptypes"
import AutosuggestBar from "../AutosuggestBar"
import "./CreateEditSubject.scss"

const CreateEditSubject = (props) => {
  return (
    <div className="CreateEditSubject">
      <div className="autosuggest-input">
        <div className="autosuggest-header">{props.autosuggestText}</div>
        <AutosuggestBar
          data={props.autosuggestData}
          onSelect={(select) =>
            props.setSubject({
              ...props.subject,
              entityId: select?.id,
              entityName: select.name ? select.name : "",
            })
          }
          placeholder={props.autosuggestPlaceholder}
          input={props.subject.entityName}
          setInput={(input) =>
            props.setSubject({ ...props.subject, entityName: input })
          }
        />
      </div>
      <div className="calendar-input">
        <div className="calendar-header">{props.calendarText}</div>
        <CalendarDropdown
          expandDirection="right"
          timezone={props.timezone}
          startDate={props.subject.startAt}
          endDate={props.subject.endAt}
          onUpdate={(startAt, endAt) => {
            props.setSubject({
              ...props.subject,
              startAt: startAt,
              endAt: endAt,
            })
          }}
          calendarOpen={true}
          allowDateTime={true}
          cannedOptions={[
            "past7Days",
            "past14Days",
            "past30Days",
            "lastWeek",
            "lastMonth",
            "customRange",
          ]}
        />
      </div>
    </div>
  )
}

CreateEditSubject.propTypes = {
  autosuggestData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subName: PropTypes.string,
    })
  ),
  autosuggestText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  autosuggestPlaceholder: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  calendarText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  timezone: PropTypes.string.isRequired,
  subject: PropTypes.shape({
    entityId: PropTypes.string,
    entityName: PropTypes.string,
    startAt: MomentPropTypes.momentObj.isRequired,
    endAt: MomentPropTypes.momentObj.isRequired,
  }),
  setSubject: PropTypes.func,
}

CreateEditSubject.defaultProps = {
  autosuggestData: [],
  autosuggestPlaceholder: "",
}

export default CreateEditSubject
